// extracted by mini-css-extract-plugin
export default {"display":"jAPNZ1Xl6f4mnOP6DXMxx"};